export default __webpack_public_path__ + "static/eu-84177b5f1f7a73cb46d1b1bae3aab252.svg";